import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "value", "defaultValue", "valueChange", "showPlusMinus", "suffixText", "prefixText", "disabled", "min", "max", "isInteger", "convertToString", "error", "errMessage", "formTitleDirection", "formTitle", "formTitleClassName", "formTitleSlot"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "containerClassName", "valueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState } from 'react';
import { Add, Remove } from '@mui/icons-material';
import { Box, FormHelperText, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import { useController } from 'react-hook-form';
import { JoveFormTitleDirectionEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var StyledTextField = styled(TextField)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& input[type=number]': {
      MozAppearance: 'textfield',
      // Firefox
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        // Chrome, Safari, Edge
        WebkitAppearance: 'none',
        margin: 0
      }
    },
    '.MuiInputBase-root': {
      'input:focus': {
        boxShadow: 'none'
      }
    }
  };
});
var JoveNumberInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      showPlusMinus = props.showPlusMinus,
      suffixText = props.suffixText,
      prefixText = props.prefixText,
      disabled = props.disabled,
      min = props.min,
      max = props.max,
      isInteger = props.isInteger,
      convertToString = props.convertToString,
      error = props.error,
      errMessage = props.errMessage,
      _props$formTitleDirec = props.formTitleDirection,
      formTitleDirection = _props$formTitleDirec === void 0 ? JoveFormTitleDirectionEnum.top : _props$formTitleDirec,
      formTitle = props.formTitle,
      formTitleClassName = props.formTitleClassName,
      formTitleSlot = props.formTitleSlot,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(String(defaultValue || '')),
      selectValue = _useState[0],
      setSelectValue = _useState[1];

  var _useState2 = useState(uniqueId()),
      inputUniqueId = _useState2[0],
      setInputUniqueId = _useState2[1];
  /**
   * methods
   */


  var numberChangeAction = function numberChangeAction(e) {
    var value = e.target.value;

    if (value !== '') {
      if (min !== undefined) {
        if (Number(value) < Number(min)) {
          value = String(min);
        }
      }

      if (max !== undefined) {
        if (Number(value) > Number(max)) {
          value = String(max);
        }
      }

      if (isInteger) {
        value = String(parseInt(value));
      }

      if (!convertToString) {
        value = Number(value);
      }
    } else {
      value = null;
    }

    setSelectValue(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  var plusAction = function plusAction() {
    var tempValue = value === undefined ? selectValue : value;
    var count = Number(tempValue || 0);
    numberChangeAction({
      target: {
        value: count + 1
      }
    });
  };

  var subtractAction = function subtractAction() {
    var tempValue = value === undefined ? selectValue : value;
    var count = Number(tempValue || 0);
    numberChangeAction({
      target: {
        value: count === 0 ? 0 : count - 1
      }
    });
  };

  var getFormTitleComponent = function getFormTitleComponent(direction) {
    return formTitleSlot ? formTitleSlot : !!formTitle ? /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle2",
      className: clsx('font-bold', formTitleClassName, direction === JoveFormTitleDirectionEnum.top ? 'mb-1' : ''),
      style: {
        color: props !== null && props !== void 0 && props.disabled ? 'rgba(0, 0, 0, 0.38)' : undefined
      },
      children: formTitle
    }) : null;
  };

  var realValue = value === undefined ? selectValue : value !== null && value !== void 0 ? value : '';
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [formTitleDirection === JoveFormTitleDirectionEnum.top && getFormTitleComponent(formTitleDirection), /*#__PURE__*/_jsxs(Box, {
      className: "flex w-full flex-row items-center space-x-2",
      children: [formTitleDirection === JoveFormTitleDirectionEnum.left && getFormTitleComponent(formTitleDirection), /*#__PURE__*/_jsxs(Box, {
        className: "flex w-0 flex-1 flex-col",
        children: [/*#__PURE__*/_createElement(StyledTextField, _objectSpread(_objectSpread({}, rest), {}, {
          key: inputUniqueId,
          type: "number",
          InputProps: {
            onWheel: function onWheel(e) {
              var _e$target;

              return (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.blur();
            },
            startAdornment: !!prefixText ? /*#__PURE__*/_jsx(InputAdornment, {
              position: "start",
              children: prefixText
            }) : null,
            endAdornment: showPlusMinus || !!suffixText ? /*#__PURE__*/_jsxs(InputAdornment, {
              position: "end",
              children: [showPlusMinus && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(IconButton, {
                  edge: "end",
                  onClick: subtractAction,
                  disabled: realValue === min,
                  children: /*#__PURE__*/_jsx(Remove, {})
                }), /*#__PURE__*/_jsx(IconButton, {
                  edge: "end",
                  onClick: plusAction,
                  disabled: realValue === max,
                  children: /*#__PURE__*/_jsx(Add, {})
                })]
              }), !!suffixText && /*#__PURE__*/_jsx("span", {
                className: "font-bold text-[#202020]",
                children: suffixText
              })]
            }) : null
          },
          value: realValue,
          onChange: numberChangeAction,
          disabled: disabled
        })), error && /*#__PURE__*/_jsx(FormHelperText, {
          error: error,
          children: errMessage
        })]
      })]
    })]
  });
});
export var JoveNumberInputControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      valueChange = props.valueChange,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveNumberInput, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      valueChange: valueChangeAction,
      defaultValue: defaultValue,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveNumberInput;